export default "__VITE_ASSET__BYXeWl8M__"